import btoa from 'btoa';
import gql from 'graphql-tag';

import config from 'js/app/config';

import type { ZoomState } from 'bundles/third-party-auth/types/ZoomState';

export const ZOOM_CLIENT_ID_DEV = 'Mz1Wn1TCTcmTAv4bK2k1yw';
export const ZOOM_CLIENT_ID_PROD = 'VzuBCh5DRhWq3K3b_JNONw';

export const getZoomOAuth2Link = (isDev: boolean, state?: ZoomState) => {
  const stateUrlParam = state ? `&state=${btoa(JSON.stringify(state))}` : '';
  const redirectURIDev = encodeURIComponent(`${config.url.base}zoom-account-linking-dev`);
  const redirectURIProd = encodeURIComponent(`${config.url.base}zoom-account-linking`);

  const redirectURI = isDev ? redirectURIDev : redirectURIProd;
  const clientId = isDev ? ZOOM_CLIENT_ID_DEV : ZOOM_CLIENT_ID_PROD;

  return `https://zoom.us/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectURI}${stateUrlParam}`;
};

/* eslint-disable graphql/template-strings */
export const ZoomAuthEmailQuery = gql`
  query ZoomAuthEmailQuery($isDev: Boolean!) {
    ZoomAuthV1Resource(isDev: $isDev)
      @rest(type: "ZoomAuthV1Resource", path: "zoomAuth.v1?q=me&fields=email&isDev={args.isDev}", method: "GET") {
      elements @type(name: "ZoomAuth") {
        id
        email
      }
    }
  }
`;
/* eslint-enable graphql/template-strings */
